import { useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Box } from '@podiumhq/design-system';

import ReviewCard from './ReviewCard';
import ReviewInviteCard from './ReviewInviteCard';

const BusinessInfoAnimations = ({ businessName, gmbReviews, showReview }) => {
  const reviewContent = useMemo(() => {
    const businessReview = gmbReviews?.find((review) => review.rating === 5);

    return {
      authorName: businessReview?.author_name || 'Kathryn Murphy',
      text:
        businessReview?.text ||
        'I had a great experience! The team was very helpful and customer service is top notch.',
      profilePhotoUrl: businessReview?.profile_photo_url || null,
      relativeTimeDescription:
        businessReview?.relative_time_description || null,
    };
  }, [gmbReviews]);

  return (
    <Box
      alignItems="center"
      display="flex"
      h="100%"
      justifyContent="center"
      w="100%"
    >
      <Box
        backgroundColor="silver.lightest"
        borderRadius="24px"
        display="flex"
        flexDirection="column"
        h="595px"
        p="48px 32px"
        w="316px"
      >
        <AnimatePresence>
          {showReview ? (
            <motion.div
              key="review-card"
              animate={{ display: 'block', opacity: 1, y: 0 }}
              exit={{ opacity: 1 }}
              initial={{ display: 'block', opacity: 0, y: 50 }}
              style={{ height: '100%', width: '100%' }}
              transition={{ delay: 0.7, duration: 1 }}
            >
              <ReviewCard businessName={businessName} {...reviewContent} />
            </motion.div>
          ) : (
            <motion.div
              key="review-invite-card"
              animate={{ opacity: 1, y: 0 }}
              exit={{
                opacity: 0,
                transition: { delay: 0.5 },
              }}
              initial={{ opacity: 0, y: 50 }}
              style={{ minHeight: 500, width: '100%' }}
              transition={{ duration: 0.5, ease: 'linear' }}
            >
              <ReviewInviteCard businessName={businessName} />
            </motion.div>
          )}
        </AnimatePresence>
      </Box>
    </Box>
  );
};

export default BusinessInfoAnimations;
